import React from "react";
import { Switch } from "@/components/ui/switch";

/** The admin's switch (components/ui/switch, as SettingsAdmin uses it). */
export default function CrmSwitch(props) {
  return <Switch {...props} />;
}
